import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { getDefaultCompanyId, sortByField } from 'utils/helpers';
import { myUserInfo } from './user/userSlice';

interface MoneyContainerState {
    moneyContainerList: any;
    loading: boolean;
    error: string;
}

const initialState: MoneyContainerState = {
    moneyContainerList: [],
    loading: true,
    error: '',
};
export const updateMerchantInfo = createAsyncThunk('updateMerchantInfo', async (companyName: string, { dispatch }) => {
    const responseData: any = await client.post(`${oldGloryBaseUrl}/merchant/updateMerchantInfo`, {
        companyName,
    });
    if (responseData?.code === 200) {
        dispatch(myUserInfo());
    }
    return responseData;
});

export const updatedAccount = createAsyncThunk('defaultAccount', async (id: string, { getState, dispatch }) => {
    const state: any = getState();
    const companyId: any = getDefaultCompanyId(state);
    const res: any = await client.put(`${oldGloryBaseUrl}/account/updateDefaultAccount`, {
        accountId: id,
        companyId,
    });
    if (res?.code === 200) {
        dispatch(getMoneyContainer());
    }
    return res;
});

export const getMoneyContainer = createAsyncThunk('moneyContainer', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const response: any = await client.get('/customer/getMoneyContainerBalances', {
        headers: {
            companyId,
        },
    });
    return sortByField(response?.moneyContainers, 'detail.default', 'DESC');
});

const getMoneyContainerSlice = createSlice({
    name: 'moneyContainer',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMoneyContainer.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getMoneyContainer.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.moneyContainerList = action?.payload || [];
        });
        builder.addCase(getMoneyContainer.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || 'error message ';
        });
    },
});

export default getMoneyContainerSlice.reducer;
